import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { GIVE_OUT } from './types';

export const giveOut = createTaskAction(GIVE_OUT);
